
import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux'; // Asegúrate de que useSelector esté importado
import { AiOutlineEdit, AiOutlineFileAdd, AiOutlineDelete } from 'react-icons/ai';
import { grupoService } from '../../services/grupo.service';
import '../../assets/styles/file-picker.css';
import { Tooltip, Modal, Box, Button, IconButton, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Select, MenuItem } from '@mui/material';
import { MdCheckCircle, MdCancel, MdHelpOutline } from 'react-icons/md';
import { userService } from '../../services/user.service';
import { ROLES } from '../../services/user.service';
import { CalendarToday as CalendarTodayIcon, CheckCircle as CheckCircleIcon, Attachment as AttachmentIcon } from '@mui/icons-material';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import CommentIcon from '@mui/icons-material/Comment';
import { BsChatSquareDotsFill } from "react-icons/bs";
import FindInPageIcon from '@mui/icons-material/FindInPage';
import FileCopyIcon from '@mui/icons-material/FileCopy'; // Para "NOMBRE DEL ARCHIVO"
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined';
import { BsPersonCircle } from 'react-icons/bs'; // Ícono para imagen predeterminada
import TablePagination from '@mui/material/TablePagination'; // Importar TablePagination
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import { saveMedioVeficiacion,updateMedioVerificacion,RemplaceMedioVerificacion,deleteMedioVerificacion} from "../../store/grupo.actions";




export function FilePicker({ customHeight, info, files, counterFile, userRol }) {
    const [fileData, setFileData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [rejectionComment, setRejectionComment] = useState('');
    const [selectedFileIndex, setSelectedFileIndex] = useState(null);
    const [user, setUser] = useState(userService.getLoggedinUser().data.data); //Usuario logueado en la interfaz

    const members = useSelector(storeState => storeState.userModule.users);

    const [ID_medio_verificacion, setIDMedioVerificacion] = useState(null);
    const [estado_verificable, setEstadoVerificable] = useState("");
    const [id_remplazo, setId_remplazo] = useState("");
    const [isRevisionModalOpen, setIsRevisionModalOpen] = useState(false);
    const fileInputRef = useRef();
    const [revisionData, setRevisionData] = useState([]); // Estado para guardar los datos de revisión
    const UrlCarpeta = info.id_carpeta_drive;
    const isEditable = userRol === ROLES.ADMIN || userRol === ROLES.TECNICO;
    const EspecialEditable = userRol === ROLES.ADMIN;
    const [loading, setLoading] = useState(false); // Estado para manejar la carga
    const [loading2, setLoading2] = useState(false); // Estado para manejar la carga


    const getUserById = (fk_usuario_id) => {
        return members.find(user => user.id_usuario === fk_usuario_id);
      };


 async function fetchRevisionDataForID(IdMedioVerificacion) {
    setLoading(true); // Inicia el estado de carga
    setRevisionData([]);
    try {
        const response = await grupoService.getDataByIDArchivo(IdMedioVerificacion);
        setRevisionData(response.hostorial_revicion || []);
    } catch (err) {
        console.error('Error al obtener los datos de revisión:', err);
    } finally {
        setLoading(false); // Finaliza el estado de carga
    }
}

function formatDate(dateString) {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // Activar formato de 12 horas con AM/PM
    };
    return date.toLocaleString("es-ES", options).replace(',', ''); // Quitar la coma si aparece
  }


const toggleRevisionModal = (IdMedioVerificacion) => {
   
    setIsRevisionModalOpen(!isRevisionModalOpen);
    if (!isRevisionModalOpen) {
       
       
    
        fetchRevisionDataForID(IdMedioVerificacion); 
       
       
    }
};


    useEffect(() => {
        if (files) {
            setFileData(files.filter(file => file.estado >= 1)); 
        }
    }, [files]);

    async function uploadFile(ev) {
        try {
            const file = ev.target.files[0];
            if (!file) return;

            setLoading2(true); // Inicia el estado de carga

            const formData = new FormData();
            formData.append('archivo', file);
            formData.append('nombre_archivo', file.name);
            formData.append('fk_actividad_id', info.id_actividad);
            formData.append('estado', 1);
            formData.append('fk_usuario_id',user.id_usuario);
           
    

            // const response = await grupoService.guardarArchivos(formData);
            const response = await saveMedioVeficiacion(formData,info.id_grupo,info.id_actividad);


            if (response.estado >= 1) {
                setFileData([...fileData, {
                    id_archivo_actividad: response.id_archivo_actividad,
                    url_archivo: response.url_archivo,
                    nombre_archivo: file.name,
                    estado: response.estado,
                    remplaza_archivo: response.remplaza_archivo,
                    fk_usuario_id: response.fk_usuario_id
                    
                }]);
                 
                counterFile(fileData.length + 1);
            }

           
        } catch (err) {
            console.error('Error al cargar archivo:', err);
        }finally {
            setLoading2(false); // Finaliza el estado de carga
        }
    }

    function getStatusIcon(estado) {
        const iconSize = { fontSize: '24px' };
        switch (estado) {
            case 'Aprobado':
                return <MdCheckCircle style={{ color: 'green', ...iconSize }} />;
            case 'Rechazado':
                return <MdCancel style={{ color: '#CD070A', ...iconSize }} />;
            default:
                return <MdHelpOutline style={{ color: 'grey', ...iconSize }} />;
        }
    }

    function getRowBorderColor(estado) {
        const borderWidth = '4px';
        switch (estado) {
            case 'Aprobado':
                return `${borderWidth} solid green`;
            case 'Rechazado':
                return `${borderWidth} solid #CD070A`;
            default:
                return `${borderWidth} solid grey`;
        }
    }

    function toggleModal() {
        setIsModalOpen(!isModalOpen);
    }

    function toggleRejectModal() {
        setRejectionComment('');  // Asigna una cadena vacía
        setIsRejectModalOpen(!isRejectModalOpen);
    }

    function handleFileClick() {
        if (isEditable) {
            fileInputRef.current.click();
        }
    }

    function handleFileSelect(idArchivoActividad) {
        grupoService.VisualizarArchivo(idArchivoActividad);
    }

    //funcion para visualizar los archivos de los medios de verificacion
    function WiewStoriesData(fkMedioVerificacion) {
       
     grupoService.VisualizarArchivo(fkMedioVerificacion);
        
    }

   

    async function handleDelete(id_archivo) {
        try {
            // const response = await grupoService.deshabilitarArchivos(id_archivo);
            const response = await deleteMedioVerificacion(id_archivo,info.id_grupo,info.id_actividad);

            if (response.success === true) {
            const newFileData = fileData.filter(file => file.id_archivo_actividad !== id_archivo);
            setFileData(newFileData);

            }
        } catch (err) {
            console.error('Error al deshabilitar el archivo:', err);
        }
    }

    function handleStatusChange(ID_medio,ID_Remplazo, newStatus) {

        
        // const selectedFile = fileData[index];
        let comentario = "Medio de Verificacion Aprobado";
        setIDMedioVerificacion(ID_medio);
        setId_remplazo(ID_Remplazo);
        setEstadoVerificable(newStatus);
        


        if (newStatus === "Aprobado") {
           
           // Actualiza el estado local sin depender del índice
            const updatedFileData = fileData.map((file) => 
                file.id_archivo_actividad === ID_medio
                    ? { ...file, estado_verificable: newStatus }
                    : file
            );
            setFileData(updatedFileData);

                EvaluarMedio(ID_medio, user.id_usuario, comentario,newStatus,ID_Remplazo);

        } else if (newStatus === "Rechazado") {
            setSelectedFileIndex(ID_medio);
            toggleRejectModal();
        } else {
            console.log("Estado desconocido.");
        }
    }

    function handleReject() {
        const updatedFileData = fileData.map((file) =>
            file.id_archivo_actividad === selectedFileIndex
                ? { ...file, estado_verificable: 'Rechazado' }
                : file
        );
        setFileData(updatedFileData);

        EvaluarMedio(ID_medio_verificacion, user.id_usuario,rejectionComment,estado_verificable, id_remplazo);
        toggleRejectModal();


    }


    async function EvaluarMedio(id_medio_verificacion, id_usuario, comentario, estado_archivo, Id_remplazo) {
        try {
            // Crear el objeto con los datos necesarios
            const Medio_verificacion = {
                fk_medio_verificacion: id_medio_verificacion,
                fk_usuario: id_usuario,
                comentario: comentario,
                estado_verificable: estado_archivo
            };
            
            // // Llamar a la API y esperar el resultado
            // const response = await grupoService.EvaluacionMVerificacion(Medio_verificacion, Id_remplazo);

            const response = await updateMedioVerificacion(Medio_verificacion,Id_remplazo,info.id_grupo,info.id_actividad,id_medio_verificacion);
            
            // Verificar la respuesta
            if (response.success) {
                // grupoService.NotificacionMedioVerificacion(id_medio_verificacion,info.name_grupo);
              
            } else {

                console.log('Error al evaluar el medio de verificación.');
            }
        } catch (error) {
            // Capturar errores y mostrar en la consola
            console.error('Ocurrió un error durante la evaluación del medio de verificación:', error);
        }
    }


    // Función para manejar el reemplazo de archivo
async function handleReplace(ev, id_archivo_actividad) {

    const file = ev.target.files[0];
    if (!file) return;
    // Obtener el identificador del archivo seleccionado
    const originalFile = fileData.find(file => file.id_archivo_actividad === id_archivo_actividad);
    const ID_ORIGINAL_ARCHIVO = originalFile?.id_archivo_actividad;

    let idArchivoActividad = originalFile?.remplaza_archivo || ID_ORIGINAL_ARCHIVO;




    try {
        const file = ev.target.files[0];
        if (!file) return;

        setLoading2(true); // Inicia el estado de carga

        const formData = new FormData();
        formData.append('archivo', file);
        formData.append('nombre_archivo', file.name);
        formData.append('fk_actividad_id', info.id_actividad);
        formData.append('estado', 1);
        formData.append('remplaza_archivo', idArchivoActividad);
        formData.append('fk_usuario_id',user.id_usuario);

        
       
        // const response = await grupoService.RemplazarArchivos(formData,ID_ORIGINAL_ARCHIVO );
        const response = await RemplaceMedioVerificacion(formData,ID_ORIGINAL_ARCHIVO,info.id_grupo,info.id_actividad);
            
        

        if (response.success) {
            // Aquí, response.data debería contener la información actualizada
            const { id_archivo_actividad, url_archivo, nombre_archivo, fk_actividad_id,estado, remplaza_archivo, estado_verificable } = response.data;

             // Actualizar el archivo en el estado
        const updatedFiles = fileData.map(file =>
            file.id_archivo_actividad === ID_ORIGINAL_ARCHIVO
                ? {
                    ...file,
                    id_archivo_actividad,
                    url_archivo,
                    nombre_archivo,
                    fk_actividad_id,
                    estado,
                    estado_verificable,
                    remplaza_archivo
                }
                : file
        );

        // Actualizar el estado
        setFileData(updatedFiles);

            
        } else {
            console.error('Error en la respuesta del servidor:', response.error);
        }
    } catch (err) {
        console.error('Error al cargar archivo:', err);
    }finally {
        setLoading2(false); // Finaliza el estado de carga
    }
}


 //para el manejo de la paginacion 
 const [page, setPage] = useState(0);  // Estado para la página actual
 const [rowsPerPage, setRowsPerPage] = useState(5); // Estado para el número de filas por página

 // Función para manejar el cambio de página
 const handleChangePage = (event, newPage) => {
     setPage(newPage);
 };

 // Función para manejar el cambio de filas por página
 const handleChangeRowsPerPage = (event) => {
     setRowsPerPage(parseInt(event.target.value, 6));
     setPage(0);  // Volver a la primera página
 };

 // Datos a mostrar en la tabla, considerando la paginación
 const paginatedData = fileData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


 //Funciones para controlar el campo de comentarios en el modal de comentarios
// Estado para controlar la fila expandida
const [expandedRowIndex, setExpandedRowIndex] = useState(null);

const handleExpandRow = (index) => {
    // Si la fila está expandida, vuelve a colapsar. Si no, expande.
    setExpandedRowIndex(expandedRowIndex === index ? null : index);
};

    return (
   
        <section className="file-picker picker" style={{ height: customHeight }}>
            <IconButton 
                onClick={toggleModal} 
                title="Archivos"
                style={{ cursor: isEditable ? 'pointer' : 'not-allowed' }}
                disabled={!isEditable}
            >
                <AiOutlineFileAdd className="icon" />
                {fileData.length > 0 && (
                    <span className="file-count">+{fileData.length}</span>
                    
                    
                )}
            </IconButton>

            <input
                type="file"
                accept="image/*,application/pdf,application/msword,application/vnd.ms-excel,application/vnd.ms-powerpoint"
                onChange={uploadFile}
                ref={fileInputRef}
                style={{ display: 'none' }}
            />

            <Modal
                open={isModalOpen}
                onClose={toggleModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box className="modal-box" sx={{ padding: '20px', width: '65%', margin: 'auto' }}>
                    <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
                        Archivos
                    </Typography>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                        <Button
                            onClick={handleFileClick}
                            variant="contained"
                            color="primary"
                            startIcon={<AiOutlineFileAdd />}
                            disabled={!isEditable}
                            style={{ marginRight: '10px' }} // Añadir margen derecho al botón
                        >
                            Agregar archivo
                        </Button>

                        {/* Mostrar el ícono de carga al lado del botón */}
                        {loading2 && <CircularProgress size={24} />} {/* Puedes ajustar el tamaño si es necesario */}
                    </Box>

                    <TableContainer component={Paper}>
    <Table>
        <TableHead>
            <TableRow>
                <TableCell></TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <BookmarkOutlinedIcon sx={{ mr: 1, color:'#30475E' }} />
                        <Typography variant="subtitle2">ESTADO DEL ARCHIVO</Typography>
                    </Box>
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <FileCopyIcon sx={{ mr: 1, color: '#30475E'}} />
                        <Typography variant="subtitle2">NOMBRE DEL ARCHIVO</Typography>
                    </Box>
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <AccountBoxIcon sx={{ mr: 1,color: '#30475E'}} />
                        <Typography variant="subtitle2">USUARIO</Typography>
                       
                    </Box>
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <AnalyticsRoundedIcon sx={{ mr: 1,color: '#30475E' }} />
                        <Typography variant="subtitle2">ACCIONES</Typography>
                    </Box>
                </TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
        {paginatedData.map((file, index) => (
                                    <TableRow key={index} style={{ borderLeft: getRowBorderColor(file.estado_verificable), marginBottom: '10px' }}>
                                        <TableCell>{getStatusIcon(file.estado_verificable)}</TableCell>
                                        <TableCell >
                                       


                                        <Select
  value={file.estado_verificable || ''}
  onChange={(e) => handleStatusChange(file.id_archivo_actividad, file.remplaza_archivo, e.target.value)}
  displayEmpty
  variant="outlined"
  disabled={!EspecialEditable}
  sx={{
    backgroundColor: 
      file.estado_verificable === 'Aprobado' ? '#067424' : 
      file.estado_verificable === 'Rechazado' ? '#a92704' : 
      '#9E9E9E', 
    color: 'white', 
    width: '145px',
    '& .MuiSelect-icon': {
      color: file.estado_verificable === '' ? 'black' : 'white',
    },
  }}
  MenuProps={{
    MenuListProps: {
      sx: {
        backgroundColor: '#f5f5f5', // Color de fondo del menú desplegable
        '& .Mui-selected': {
          backgroundColor: '#797d7d', // Color del elemento seleccionado (amarillo oro en este ejemplo)
          color: 'white', // Color del texto del elemento seleccionado
          '&:hover': {
            backgroundColor: '#a8aaaa', // Color al hacer hover sobre el seleccionado
          },
        },
      },
    },
  }}
>
  <MenuItem
    value=""
    disabled
    sx={{
      backgroundColor: '#9E9E9E',
      color: 'white',
      '&:hover': { backgroundColor: '#757575' },
    }}
  >
    <Typography fontWeight="bold">Sin Aprobación..</Typography>
  </MenuItem>

  <MenuItem
    value="Aprobado"
    sx={{
      backgroundColor: '#067424',
      color: 'white',
      '&:hover': { backgroundColor: '#026B1E' },
    }}
  >
    <Typography fontWeight="bold">Aprobado</Typography>
  </MenuItem>

  <MenuItem
    value="Rechazado"
    sx={{
      backgroundColor: '#b12904',
      color: 'white',
      '&:hover': { backgroundColor: '#aa2503' },
    }}
  >
    <Typography fontWeight="bold">Rechazado</Typography>
  </MenuItem>
</Select>









                                       {/* Botón para abrir el modal de revisión */}

                                       {file.estado_verificable && (
                                         <Tooltip title="Ver Comentarios" arrow>
                                        <IconButton 
                                            onClick={() => toggleRevisionModal(file.remplaza_archivo ? file.remplaza_archivo : file.id_archivo_actividad)} 
                                        >
                                            <BsChatSquareDotsFill />
                                        </IconButton>
                                         </Tooltip>
                                    )}
                                    </TableCell>
                                    <TableCell>
                                    <Tooltip title={file.nombre_archivo} arrow>
                                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block', maxWidth: '220px' }}>
                                            {file.nombre_archivo}
                                        </span>
                                    </Tooltip>
                                </TableCell>

    <TableCell>
      {file.fk_usuario_id ? (
        (() => {
          const user = getUserById(file.fk_usuario_id);
          return user ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {/* Si hay URL de imagen, mostrarla */}
              {user.imgurl ? (
                <img
                  src={user.imgurl}
                  alt={user.nombre || 'Usuario sin nombre'} // Texto alternativo si no hay nombre
                  style={{ width: '25px', height: '25px', borderRadius: '50%', marginRight: '10px' }}
                  onError={(e) => {
                    e.target.onerror = null; // Evitar loop infinito si falla de nuevo
                    e.target.src = 'https://via.placeholder.com/30'; // Imagen de reemplazo si falla
                  }}
                />
              ) : (
                <BsPersonCircle style={{ fontSize: '30px', marginRight: '10px' }} />
              )}
              {/* Mostrar nombre o texto predeterminado si no existe */}
              <span>{user.nombre || 'Nombre no disponible'}</span>
            </div>
          ) : (
            <span>Usuario</span>
          );
        })()
      ) : (
        <span>Usuario</span>
      )}
    </TableCell>

                                        <TableCell>
                                    {/* Botón de Ver Archivo */}
                                    <Tooltip title="Ver Archivo" arrow>
                                        <IconButton
                                       onClick={() => handleFileSelect(file.id_archivo_actividad)}
                                        sx={{
                                            backgroundColor: '#f5f5f5',  // Fondo claro
                                            borderRadius: '50%',        // Redondear los bordes
                                            p: 1,                       // Padding
                                            '&:hover': {
                                            backgroundColor: '#e0e0e0', // Cambia el fondo en hover
                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)', // Sombra en hover
                                            },
                                        }}
                                        >
                                        <RemoveRedEyeOutlinedIcon
                                        
                                            sx={{ color: '#404258', fontSize: '1.5rem' }} // Cambiar color y tamaño del ícono
                                        />
                                        </IconButton>
                                    </Tooltip>

                                    {/* Botón de Remplazar Archivo */}
                                    <input type="file" style={{ display: 'none' }} id={`fileInput-${index}`}  onChange={(ev) => handleReplace(ev, file.id_archivo_actividad)}/>
                                    <Tooltip title="Remplazar Archivo" arrow>
                                        <IconButton onClick={() => document.getElementById(`fileInput-${index}`).click()}
                                        sx={{ marginLeft: '4px',backgroundColor: '#f5f5f5',borderRadius: '50%',
                                            p: 1,
                                            '&:hover': {
                                            backgroundColor: '#e0e0e0',
                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                                            },
                                        }}
                                        >
                                        <AiOutlineEdit
                                            style={{ color: '#50577A', fontSize: '1.5rem' }} // Color verde para resaltar
                                        />
                                        </IconButton>
                                    </Tooltip>

                                    {/* Botón de Eliminar Archivo */}
                                    <Tooltip title="Eliminar Archivo" arrow>
                                        <IconButton onClick={() => handleDelete(file.id_archivo_actividad)}
                                        sx={{  marginLeft: '4px',backgroundColor: '#f5f5f5', borderRadius: '50%',
                                            p: 1,
                                            '&:hover': {
                                            backgroundColor: '#e0e0e0',
                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                                            },
                                        }}
                                        >
                                        <AiOutlineDelete
                                            style={{ color: '#d32f2f', fontSize: '1.5rem' }} // Color rojo para eliminar
                                        />
                                        </IconButton>
                                    </Tooltip>
                                    </TableCell>


                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                      {/* Componente de paginación */}
                        <TablePagination
                        rowsPerPageOptions={[5, 10]}
                            component="div"
                            count={fileData.length}  // Cantidad total de filas
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Box>
            </Modal>

            {/* Modal para comentario de rechazo */}
            <Modal
                open={isRejectModalOpen}
                onClose={toggleRejectModal}
                aria-labelledby="reject-modal-title"
                aria-describedby="reject-modal-description"
            >
                <Box className="modal-box" sx={{ padding: '20px', width: '600px', margin: 'auto', textAlign: 'center' }}>
                    <Typography id="reject-modal-title" variant="h6" component="h2" gutterBottom>
                        Comentario de Rechazo
                    </Typography>
                    <TextField
                        label="Escribe el comentario"
                        value={rejectionComment}
                        onChange={(e) => setRejectionComment(e.target.value)}
                        multiline
                        fullWidth
                        minRows={4}  // Mínimo número de filas
                        maxRows={10} // Máximo número de filas antes de habilitar el scroll
                        margin="normal"
                    />
                   <Button
                    onClick={handleReject}
                    variant="contained"
                    sx={{ backgroundColor: '#1a6ed3', color: 'white', marginTop: '10px' }}
                >
                    Rechazar
                </Button>
                </Box>
            </Modal>

             
            {/* Modal para mostrar la tabla de 'solicitudes_revision' */}
            <Modal
    open={isRevisionModalOpen}
    onClose={toggleRevisionModal}
    aria-labelledby="revision-modal-title"
    aria-describedby="revision-modal-description"
>
    <Box 
        className="modal-box" 
        sx={{
            padding: '20px',
            width: '1000px',
            maxWidth: '1050px',
            margin: 'auto',
            maxHeight: '90vh',
            overflow: 'hidden',
            bgcolor: '#f9f9f9',
        }}
    >
        <Typography 
            id="revision-modal-title" 
            variant="h6" 
            component="h2" 
            align="left" 
            gutterBottom
            sx={{ fontWeight: 'bold', color: '#333' }}
        >
            Historial de Revisiones
        </Typography>

        <TableContainer component={Paper} sx={{ maxHeight: '70vh', overflowY: 'auto', bgcolor: '#fff', borderRadius: '8px', boxShadow: 3 }}>
            <Table stickyHeader>
                <TableHead sx={{ bgcolor: '#3f51b5', color: '#fff' }}>
                    <TableRow>
                        <TableCell sx={{ width: '650px', fontWeight: 'bold', color: '#000' }} align="center">
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CommentIcon sx={{ mr: 1 }} />
                                <Typography variant="subtitle2">COMENTARIO</Typography>
                            </Box>
                        </TableCell>
                        <TableCell sx={{ width: '250px', fontWeight: 'bold', color: '#000' }} align="center">
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CalendarTodayIcon sx={{ mr: 1 }} />
                                <Typography variant="subtitle2">FECHA REVISIÓN</Typography>
                            </Box>
                        </TableCell>
                        <TableCell sx={{ width: '150px', fontWeight: 'bold', color: '#000' }} align="center">
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CheckCircleIcon sx={{ mr: 1 }} />
                                <Typography variant="subtitle2">ESTADO</Typography>
                            </Box>
                        </TableCell>
                        <TableCell sx={{ width: '160px', fontWeight: 'bold', color: '#000' }} align="center">
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <PermContactCalendarIcon sx={{ mr: 1 }} />
                                <Typography variant="subtitle2">REVISADO</Typography>
                            </Box>
                        </TableCell>
                        <TableCell sx={{ width: '140px', fontWeight: 'bold', color: '#000' }} align="center">
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <AttachmentIcon sx={{ mr: 1 }} />
                                <Typography variant="subtitle2">ARCHIVO</Typography>
                            </Box>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading ? ( // Muestra el ícono de carga si está cargando
                        <TableRow>
                            <TableCell colSpan={4} align="center">
                                <CircularProgress />
                            </TableCell>
                        </TableRow>
                    ) : revisionData.length > 0 ? (
                        revisionData.map((revision, index) => (
                            // Oculta las demás filas si una está expandida
                            (expandedRowIndex === null || expandedRowIndex === index) && (
                                <TableRow 
                                    key={index} 
                                    sx={{ '&:nth-of-type(odd)': { bgcolor: '#f5f5f5' }, '&:hover': { bgcolor: '#e0e0e0' } }}
                                >
                                    <TableCell colSpan={expandedRowIndex === index ? 4 : undefined}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleExpandRow(index)}>
                                                {expandedRowIndex === index ? <CloseIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                            <TextField
                                                value={revision.comentario}
                                                multiline
                                                maxRows={expandedRowIndex === index ? 10 : 4}
                                                fullWidth
                                                variant="outlined"
                                                InputProps={{ readOnly: true }}
                                                sx={{
                                                    width: expandedRowIndex === index ? '100%' : '90%',
                                                    maxHeight: expandedRowIndex === index ? '400px' : '150px',
                                                    overflow: 'auto',
                                                    bgcolor: '#fafafa',
                                                }}
                                            />
                                        </Box>
                                    </TableCell>
                                    {expandedRowIndex !== index && (
                                        <>
                                            <TableCell align="center">
                                                 {formatDate(revision.created_at)}
                                            </TableCell>
                                            <TableCell align="center" sx={{ color: revision.estado_verificable === 'Rechazado' ? 'red' : revision.estado_verificable === 'Aprobado' ? 'green' : 'inherit' }}>
                                            {revision.estado_verificable}
                                        </TableCell>

                                        <TableCell align="center">
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                                                {getUserById(revision.fk_usuario)?.imgurl ? (
                                                    <img
                                                        src={getUserById(revision.fk_usuario).imgurl}
                                                        alt="Usuario"
                                                        style={{
                                                            width: '25px',
                                                            height: '25px',
                                                            borderRadius: '50%',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                ) : (
                                                    <BsPersonCircle style={{ fontSize: '40px', color: '#ccc' }} />
                                                )}
                                                <Typography variant="body2" sx={{ fontWeight: '300', color: '#333' }}>
                                                    {getUserById(revision.fk_usuario)?.nombre || 'Sin nombre'}
                                                </Typography>
                                            </Box>
                                            </TableCell>
                                            <TableCell align="center">
                                                <IconButton onClick={() => WiewStoriesData(revision.fk_medio_verificacion)}>
                                                    <FindInPageIcon />
                                                </IconButton>
                                            </TableCell>
                                        </>
                                    )}
                                </TableRow>
                            )
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={4} align="center">
                                No hay revisiones disponibles.
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>

            </Table>
        </TableContainer>
    </Box>
</Modal>
        </section>
    );
}
